import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import {
  Navbar,
  ProfileDropdown,
  ProfileMobile,
  addDomain,
  DEFAULT_PATH_MAP
  // @ts-ignore
} from '@safetywing-tech/feather/navbar';
// @ts-ignore
import featherCss from '@safetywing-tech/feather/styles.css?raw';
import { logOutUser } from 'state/app';

const Wrapper = styled.div`
  position: absolute;
  z-index: 5;

  ${featherCss};

  /* Set the Inter font variable used by feather's Tailwind styles */
  --font-inter: 'Inter', sans-serif;

  /* Reset font rendering so feather fonts match the reference */
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
  font-feature-settings: normal;
  font-variation-settings: normal;

  /* Reset global heading styles so feather's Tailwind classes take precedence */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    margin: 0;
  }
`;

const GlobalNavigation = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  // @ts-ignore
  const { user, isInitInProgress } = useSelector((state) => state.app);

  const mainSiteUrl = window.location.origin;

  const pathMap = useMemo(() => {
    return Object.entries(DEFAULT_PATH_MAP as Record<string, string>).reduce(
      (acc: Record<string, string>, [key, path]) => {
        if (path && !path.startsWith('http')) {
          acc[key] = addDomain(mainSiteUrl, path);
        }
        return acc;
      },
      {}
    );
  }, [mainSiteUrl]);

  const personalDetails = user?.isAuthenticated
    ? {
        user: { email: user.email },
        profile: { firstName: user.firstName, lastName: user.lastName }
      }
    : undefined;

  const handleLogout = () => {
    dispatch(logOutUser());
  };

  return (
    <Wrapper>
      <Navbar
        hasToken={Boolean(user?.isAuthenticated || isInitInProgress)}
        linkComponent="a"
        pathname={pathname}
        pathMap={pathMap}
        profileDropdown={
          <ProfileDropdown personalDetails={personalDetails} onLogout={handleLogout} />
        }
        profileMobile={
          <ProfileMobile personalDetails={personalDetails} onLogout={handleLogout} />
        }
      />
    </Wrapper>
  );
};

export default GlobalNavigation;
